import { render, staticRenderFns } from "./ProfileListAddNew.vue?vue&type=template&id=ddc2fc16&"
import script from "./ProfileListAddNew.vue?vue&type=script&lang=js&"
export * from "./ProfileListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProfileListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports